import React, { useState } from 'react';
import { handleDownloadPhotos } from './DownloadUtils';  // Asegúrate de que la función 'handleDownloadPhotos' esté importada
import { logError } from '../../api';

const DisplayPhotos = ({ orderId, showPhotosModal, setShowPhotosModal }) => {
  const [photos, setPhotos] = useState([]);

  const handleViewPhotos = async () => {
    try {
      const { photosData, modalState } = await showPhotosModalHandler(orderId, showPhotosModal);
      setPhotos(photosData || []);
      setShowPhotosModal(modalState);
    } catch (error) {
      logError(error);
      console.error('Error al obtener las fotos:', error);
      alert('Ocurrió un error al obtener las fotos.');
    }
  };

  return (
    <>
      {/* Aquí agregamos un contenedor debajo de la fila actual */}
      {showPhotosModal && (
        <div
          className="photo-modal"
          style={{
            padding: '20px',
            backgroundColor: '#f4f4f4',
            borderRadius: '8px',
            marginTop: '20px', // Agregar un espacio antes del modal para que no esté pegado a los demás elementos
          }}
        >
          <div>
            {photos && photos.length > 0 ? (
              photos.map((photo, index) => (
                <div key={index} style={{ marginBottom: '10px' }}>
                  <img
                    src={`data:image/jpeg;base64,${photo}`}
                    alt={`Foto ${index + 1}`}
                    style={{
                      maxWidth: '200px',
                      maxHeight: '200px',
                      objectFit: 'cover',
                      marginRight: '10px',
                    }}
                  />
                </div>
              ))
            ) : (
              <p>No hay fotos disponibles para esta entrega.</p>
            )}
          </div>
          <button
            onClick={() => setShowPhotosModal(false)}
            className="close-button"
            style={{
              backgroundColor: 'red',
              color: 'white',
              border: 'none',
              padding: '5px 10px',
              cursor: 'pointer',
            }}
          >
            Cerrar fotos
          </button>
        </div>
      )}

      {/* Botón para abrir el modal de fotos */}
      {!showPhotosModal && (
        <button
          onClick={handleViewPhotos}
          className="view-photos-button"
          style={{
            backgroundColor: '#17a2b8',
            color: '#fff',
            padding: '10px 20px',
            borderRadius: '5px',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            fontSize: '16px',
          }}
        >
          Ver Fotos
        </button>
      )}
    </>
  );
};

export const showPhotosModalHandler = async (orderId, currentModalState) => {
  try {
    if (currentModalState) {
      return { photosData: [], modalState: false }; // Cierra el modal
    } else {
      const photosData = await handleDownloadPhotos(orderId);
      return { photosData, modalState: true }; // Abre el modal
    }
  } catch (error) {
    logError(error);
    console.error('Error al obtener las fotos:', error);
    return { photosData: [], modalState: false }; // En caso de error, se cierra el modal
  }
};

export default DisplayPhotos;
